import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Icon, Message } from "semantic-ui-react";
import { walmartMXTranslations } from "../../../translations/walmartMXTranslations"
import { getReadableClientName } from "../../../libs/common_utils"
import { Config } from "../../../config/api";

const RetiredAudienceWarning = ({ audiences = [] }) => {
  const intl = useIntl();
  const warningMessage = getReadableClientName(Config.public_client).toLowerCase() === "walmart"
                      ? walmartMXTranslations.retiredSegmentWarning
                      : intl.formatMessage({
                        id: "WARNING_RETIRED_AUDIENCE",
                        defaultMessage: "This strategy is targeting one or more audience segments that have been discontinued or updated. While the strategy can continue to run, these segments must be removed or replaced before edits to the strategy can be removed.",
                      })

  return (
    <Message
      warning
      className="retired-audience-warning"
    >
      <Icon aria-label="Warning" name="warning circle" />
      <div>
        <p>
          {warningMessage}
        </p>
        <ul>
          {audiences.map((audience) => (
            <li key={audience}>{audience}</li>
          ))}
        </ul>
      </div>
    </Message>
  );
};

export default RetiredAudienceWarning;

RetiredAudienceWarning.propTypes = {
  audiences: PropTypes.arrayOf(PropTypes.string),
};
